"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.vehicleToTransportMode = exports.transportModeToVehicles = void 0;
var utils_1 = require("./utils");
var transportModeToVehicles = function (transportMode) {
    switch (transportMode) {
        case 'AMB':
            return ['AMBULANCE', 'BARIATRIC', 'MEDICAL', 'PARAMEDICAL'];
        case 'TAP':
            return ['VSL', 'TAXI'];
        case 'TPMR':
            return ['TPMR'];
    }
    (0, utils_1.assertUnreachable)(transportMode);
};
exports.transportModeToVehicles = transportModeToVehicles;
var vehicleToTransportMode = function (vehicle) {
    switch (vehicle) {
        case 'AMBULANCE':
        case 'BARIATRIC':
        case 'MEDICAL':
        case 'PARAMEDICAL':
            return 'AMB';
        case 'VSL':
        case 'TAXI':
            return 'TAP';
        case 'TPMR':
            return 'TPMR';
        case 'TPS':
            throw Error('TPS in vehicleToTransportMode');
    }
    (0, utils_1.assertUnreachable)(vehicle);
};
exports.vehicleToTransportMode = vehicleToTransportMode;
//# sourceMappingURL=tdr.js.map